import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
import { adimYontemleri } from "./ndt-yeterlilik.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). */
export const NDT_BELGE_TURU = "ndt";
/** Okunan Documents türleri (N1): Finishing NDT raporu ve Step report. */
export const NDT_GELEN_TURLERI = ["hat_ndt", "adim_raporu"];
export const ndtGelenTuruMu = (t) => NDT_GELEN_TURLERI.includes(t ?? "");
/** Olay kaydında nesne tipi (nesneId = ndt_raporu_kaydi.id). */
export const NDT_OLAY_NESNESI = "ndt_raporu_kaydi";
/** Okunan hafif excel'in belge ailesi. Aile eşitliğiyle sayan hiçbir sorgu bu adı almaz (Finishing yalnız "NDT" + kaynak ekran "assembly"). */
export const NDT_GIRDI_AILESI = "NDT-report-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const NDT_EXCEL_ADI = "NDT report";
/** Bir PDF'te en çok rapor ("Documents in file"). */
export const NDT_RAPOR_EN_COK = 40;
/** Okuma işi kodu ("NDTR-7C41D2A0"): "NDT-" ve "NR-" uyarı kodlarıyla karışmasın diye "NDTR". */
export const ndtKodu = (kayitId) => `NDTR-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Raporun okunan alanları (sabit sıra; sözleşme §4.3, sürüm 2). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni hem ROWS'taki Field adıdır (S2). */
export const NDT_RAPOR_ALANLARI = [
    { alan: "form_kodu", etiket: "Form code", kimlik: false }, { alan: "baslik", etiket: "Report title", kimlik: false },
    { alan: "yontem", etiket: "Method", kimlik: false }, { alan: "rapor_no", etiket: "Report number", kimlik: false },
    { alan: "parca_tanimi", etiket: "Part description", kimlik: false },
    { alan: "riser_no", etiket: "Riser number", kimlik: true }, { alan: "hat_sn", etiket: "Serial number", kimlik: true },
    { alan: "diger_sn", etiket: "Other serial number", kimlik: true },
    { alan: "kabul_standardi", etiket: "Acceptance standard", kimlik: false }, { alan: "malzeme_durumu", etiket: "Material condition", kimlik: false },
    { alan: "cihazlar", etiket: "Equipment", kimlik: false }, { alan: "sarf_parti", etiket: "Consumable batch", kimlik: true },
    { alan: "sarf_son_kullanma", etiket: "Consumable use-by date", kimlik: false }, { alan: "test_tarihi", etiket: "Test date", kimlik: false },
    { alan: "muayeneci", etiket: "Inspector name", kimlik: false },
    { alan: "muayeneci_no", etiket: "Inspector certificate number", kimlik: true }, { alan: "seviye", etiket: "Inspector level", kimlik: false },
    { alan: "imza", etiket: "Signed", kimlik: false },
];
/**
 * D-074 Faz 2 · PR 9b: sürüm 1'in (PR 9) artık okunmayan alanları: yalnız kartta gösteriliyordu ya da kuralı kapalı (imza_tarihi: K28).
 * Eski motorun excel'inde bu satırlar yok sayılır; eski okumaların kartında değerleri görünür. Kural açılınca alan NDT_RAPOR_ALANLARI'na döner.
 */
export const NDT_ESKI_ALANLARI = [
    { alan: "is_emri", etiket: "Work order", kimlik: false }, { alan: "miktar", etiket: "Quantity", kimlik: false },
    { alan: "prosedur", etiket: "Procedure", kimlik: false }, { alan: "teknik", etiket: "Technique", kimlik: false },
    { alan: "imza_tarihi", etiket: "Signature date", kimlik: false }, { alan: "yorumlar", etiket: "Comments", kimlik: false },
];
/** Kartın değer sırası: sürüm 1'in 24 alanlık sırası (eski okumada bütün değerler bu sırayla görünür; yeni okumada eski alanların değeri yoktur). */
export const NDT_KART_SIRASI = [
    "form_kodu", "baslik", "yontem", "rapor_no", "is_emri", "parca_tanimi", "riser_no", "hat_sn", "diger_sn", "miktar", "prosedur", "teknik",
    "kabul_standardi", "malzeme_durumu", "cihazlar", "sarf_parti", "sarf_son_kullanma", "test_tarihi", "imza_tarihi", "muayeneci", "muayeneci_no",
    "seviye", "imza", "yorumlar",
];
export const ndtEtiketi = (alan) => [...NDT_RAPOR_ALANLARI, ...NDT_ESKI_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (N6; uzun biçim: rapor başına her alan bir satır). `Outcome` sürüm 2'de boş yazılır (kolon S2 gereği kalır). */
export const NDT_SATIR_BASLIKLARI = ["Report", "Pages", "Field", "Value", "Outcome", "As written", "Page", "Certainty"];
/** Sürüm 1'in sonuç satırının Field adı: sürüm 2'de yazılmaz; eski excel'de yok sayılır. */
export const NDT_SONUC_ALANI = "Result";
/* ---------------- aşama ve yöntem (N10-N12; yalnız kesin değerler) ---------------- */
export const NDT_ASAMALARI = ["bevel", "kaynak_sonrasi", "pwht_sonrasi", "basinc_sonrasi"];
/** Aşamanın ekran adı (sözlükte). */
export const NDT_ASAMA_ADI = {
    bevel: "before welding (bevel)", kaynak_sonrasi: "as welded", pwht_sonrasi: "post-weld heat treated", basinc_sonrasi: "after the pressure test",
};
/** Alanın kesin değeri (yoksa null). */
const kesinDeger = (degerler, alan) => {
    const d = degerler.find((x) => x.alan === alan);
    return d && d.kesinlik === "kesin" && d.deger !== null ? d.deger : null;
};
/**
 * Raporun aşaması (N10). İşaretler: basınç testinden sonra (başlık, rapor no ya da form kodunda "DPI-R" ya da "POST PRESSURE"; "DPI-001" gibi PT
 * rapor no'su sayılmaz), bevel (rapor no'da "-BW-" ya da malzeme durumunda "before weld", "pre-weld", "bevel"), PWHT sonrası, kaynak sonrası.
 * Tek işaret → o aşama; hiç → null; birden çok farklı → null ve `belirsiz`.
 */
export function ndtAsamasi(degerler) {
    const k = (alan) => kesinDeger(degerler, alan);
    const isaretler = new Set();
    const basinc = /\bDPI-R\b|POST\s+PRESSURE/i;
    if ([k("baslik"), k("rapor_no"), k("form_kodu")].some((v) => v !== null && basinc.test(v)))
        isaretler.add("basinc_sonrasi");
    const raporNo = k("rapor_no");
    const malzeme = k("malzeme_durumu");
    if ((raporNo !== null && /-BW-/i.test(raporNo)) || (malzeme !== null && /before\s+weld|pre-?\s*weld|bevel/i.test(malzeme)))
        isaretler.add("bevel");
    if (malzeme !== null && /post[-\s]*weld[-\s]+heat|heat[-\s]+treat|PWHT/i.test(malzeme))
        isaretler.add("pwht_sonrasi");
    if (malzeme !== null && /as\s+welded|after\s+weld|post[-\s]*weld(?![-\s]+heat)/i.test(malzeme))
        isaretler.add("kaynak_sonrasi");
    if (isaretler.size === 1)
        return { asama: [...isaretler][0], belirsiz: false };
    return { asama: null, belirsiz: isaretler.size > 1 };
}
/** Rota adımının aşaması (N12; S3: adlar değişmez, yalnız okunur). "Re-NDT", "NDT: MPI (internal surface)", "NDT: RT + DPI" null: kişi seçer. */
export function adimAsamasi(ad) {
    if (/post-test/i.test(ad))
        return "basinc_sonrasi";
    if (/post-PWHT/i.test(ad))
        return "pwht_sonrasi";
    if (/bevel/i.test(ad))
        return "bevel";
    if (/Hardness/.test(ad))
        return "kaynak_sonrasi";
    return null;
}
/** Form kodu → yöntem (N11): Q harfi şarttır (OSIUK-W-… kaynak formudur). */
const FORM_YONTEMI = [
    [/OSIUK-Q-FM-0010\b/i, "PT"], [/OSIUK-Q-FM-0011\b/i, "MT"], [/OSIUK-Q-FM-0012\b/i, "UT"], [/(?:^|[^\w.])F\.008\b/i, "RT"],
];
/** Raporun yöntemi (N11): "Method" kesin değerinin ilk yöntemi (MPI → MT, DPI → PT); yoksa form kodundan; yoksa null. */
export function ndtYontemi(degerler) {
    const yontem = kesinDeger(degerler, "yontem");
    // Değer kısaltmadır (sözleşme §4.4); küçük harfle yazılmış kısaltma da okunur.
    const y = yontem ? adimYontemleri(yontem.toUpperCase())[0] : undefined;
    if (y)
        return y;
    const form = kesinDeger(degerler, "form_kodu");
    if (form)
        for (const [kalip, v] of FORM_YONTEMI)
            if (kalip.test(form))
                return v;
    return null;
}
/* ---------------- uyarılar (N24) ---------------- */
/** Üretilen kodlar (üretim sırası). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). */
export const NDT_UYARI_KODLARI = [
    "KIM-01", "KIM-02", "KIM-07", "KIM-08", "KIM-03", "KIM-04", "KIM-05", "KIM-06", "NR-01", "NDT-05", "NDT-03", "NDT-02", "NDT-06", "NDT-04",
    "NR-02", "NR-03", "NR-04", "NR-05", "NR-06", "NR-08", "GEN-13", "GEN-09",
];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). KIM kalıpları hidrotestinkiyle aynı nesnelerdir. */
export const NDT_UYARI_KALIPLARI = {
    "KIM-01": HIDROTEST_UYARI_KALIPLARI["KIM-01"], "KIM-02": HIDROTEST_UYARI_KALIPLARI["KIM-02"], "KIM-03": HIDROTEST_UYARI_KALIPLARI["KIM-03"],
    "KIM-04": HIDROTEST_UYARI_KALIPLARI["KIM-04"], "KIM-05": HIDROTEST_UYARI_KALIPLARI["KIM-05"], "KIM-07": HIDROTEST_UYARI_KALIPLARI["KIM-07"],
    "KIM-08": HIDROTEST_UYARI_KALIPLARI["KIM-08"],
    "KIM-06": "Riser {0} is not in OASIS yet. The file waits for it.",
    // D-074 Faz 2 · PR 11 (G37): basılı aşama ile işin PWHT grafiği tarihlerinin söylediği aşama farklı; tarih kazanır (K9).
    "NR-01": { oneri: "Material condition says {0}; dates say {1}. Filed as {1}.", kisi: "Material condition says {0}; dates say {1}." },
    "NDT-02": "Signer not qualified on the report date: {0}, {1}, {2}.",
    "NDT-03": "No {0} certificate for {1}.",
    "NDT-04": "Certificate number on the report belongs to another inspector.",
    "NDT-05": "Signer has no certificate in Registers: {0}.",
    "NDT-06": "Level 1 signer. Level 2 or 3 is required.",
    "NR-02": { tarihli: "NDT equipment {0} not in Registers or not calibrated on {1}.", tarihsiz: "NDT equipment {0} not in Registers." },
    "NR-03": "Consumable {0} used after its use-by date.",
    "NR-04": "Acceptance standard {0} is not API 16C or API 16F.",
    "NR-05": "Report number {0} is already filed for {1}.",
    "NR-06": "No hardness values on file for {0}.",
    "NR-08": "Covers pin sealing areas, not welds.",
    "GEN-13": "No signature in the inspector's signature block.",
    "GEN-09": "Several documents in one file. Check the page ranges.",
};
/** N27: kartta yalnız dosyalayabilene ve karar verebilene gösterilen imzacı uyarıları. */
export const NDT_KISI_KODLARI = ["NDT-02", "NDT-03", "NDT-04", "NDT-05", "NDT-06"];
/** Hedefler aynı yer mi (N21, N22): tür + (rn, hat) ya da (tamirId, adim); öteki türlerde bütün alanlar. Biri boşsa false. */
export function hedefEsit(a, b) {
    if (!a || !b || a.tur !== b.tur)
        return false;
    if (a.tur === "hat_ndt" && b.tur === "hat_ndt")
        return a.rn === b.rn && a.hat === b.hat;
    if (a.tur === "adim_raporu" && b.tur === "adim_raporu")
        return a.tamirId === b.tamirId && a.adim === b.adim;
    if (a.tur === "pwht" && b.tur === "pwht")
        return a.tamirId === b.tamirId && a.adim === b.adim;
    if (a.tur === "ht" && b.tur === "ht")
        return a.rn === b.rn && a.hat === b.hat;
    // D-074 Faz 5 · PR 25 (M14-33): boya yeri final taşımaz; yalnız riser karşılaştırılır.
    if (a.tur === "boya" && b.tur === "boya")
        return a.rn === b.rn;
    const sirali = (h) => JSON.stringify(Object.keys(h).sort().map((k) => [k, h[k] ?? null]));
    return sirali(a) === sirali(b);
}
//# sourceMappingURL=ndt-raporu.js.map